import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Page from '../../../components/Editor/Page';
import {
	isEditablePage,
	getPageEditableTextFieldsIds,
	getPageEditableMediaIds,
	getPageEditableLinksIds,
	getPageEditableButtonsIds,
	getPageEditableIframesIds,
	getPageEditableEnrichmentsIds,
	getPageEditableSlidersIds,
	getPageThemedItemsIds,
	getIsTransparentPage,
} from '../selectors';
import { EditorType } from '../constants';
import { getClientAndResourceIds } from '../utils/helpers';
import UrlUtils from '../../../utils/url';

interface PageOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: PageOwnProps) => {
	const {
		editor: {
			type,
			pagesController: { spreads, prevSpreadIndex },
			pages,
			activeItem,
			configs: { pagesData },
			isAccessibleVersion,
		},
		galleryInfos,
	} = state;

	const { tempGId: resourceId } = getClientAndResourceIds();
	const prevPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1; // for HTML editor only
	const { fontsPath, googleFontsPath } = pages[pages[page] ? page : prevPage];
	const showAloneSide = type === EditorType.INDESIGN && pagesData[page - 1]
		? pagesData[page - 1].showAloneSide
		: undefined;

	return {
		editorType: type,
		html: pages[page] ? pages[page].html : '',
		isEditable: isEditablePage(state, page) || isAccessibleVersion,
		editableTextFieldsIds: getPageEditableTextFieldsIds(state, page),
		editableMediaIds: getPageEditableMediaIds(state, page),
		editableLinksIds: getPageEditableLinksIds(state, page),
		editableButtonsIds: getPageEditableButtonsIds(state, page),
		editableIframesIds: getPageEditableIframesIds(state, page),
		editableEnrichmentsIds: getPageEditableEnrichmentsIds(state, page),
		editableSlidersIds: getPageEditableSlidersIds(state, page),
		themedItemsIds: getPageThemedItemsIds(state, page),
		isSomeEditableItemActive: !!activeItem.id && activeItem.page === page,
		iframeUrl: UrlUtils.getComponentUrl(galleryInfos, resourceId),
		fontsPath,
		googleFontsPath,
		isTransparent: getIsTransparentPage(state, page),
		showAloneSide,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Page/index.tsx